module.exports = __webpack_public_path__ + "assets/a980591f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/movie-yellow.png
// module id = 94
// module chunks = 0